var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header",class:_vm.headerClasses,style:({ backgroundImage: _vm.backgroundImage })},[_vm._t("default"),_c('sbpro-border',{attrs:{"border-type":_vm.borderType,"border-classes":_vm.borderClasses}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }